import STYLES from './DesktopIcon.module.scss';
import { desktopIconData } from '../../../../images/imageData';

const DesktopIcon = ({ icon, label, altText, onClick }) => {
  return (
    <button className={STYLES.DesktopIcon} onClick={onClick}>
      <img
        src={icon || desktopIconData.fallback}
        alt={altText}
        className={STYLES.DesktopIcon__image}
      />
      <span className={STYLES.DesktopIcon__label}>{label}</span>
    </button>
  );
};

export default DesktopIcon;
